export const PsController: React.FC<React.SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg
    width="850"
    height="567"
    viewBox="0 0 850 567"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M218.72 20.1164C218.331 19.93 218.045 19.7925 217.89 19.7407C217.384 19.5708 216.938 16.1789 216.472 12.6267C216 9.03239 215.506 5.27389 214.906 4.52256C213.712 3.02869 193.777 -0.433154 180.885 0.0443326C164.77 0.641191 146.864 4.52095 134.032 9.89268C123.766 14.1901 110.157 22.0304 104.786 25.4126C104.388 29.889 103.294 38.2451 102.697 40.6325C102.572 41.1326 101.055 41.3998 99.014 41.7595C95.4171 42.3933 90.1904 43.3143 88.0737 46.3026C72.8538 67.7895 33.1718 175.522 23.3143 220.585C22.8789 222.576 22.3933 224.762 21.8666 227.133C12.2867 270.264 -10.9076 374.69 6.00528 479.92C11.377 513.343 32.2669 547.664 58.5287 556.915C72.1609 561.717 90.8941 563.421 105.049 564.709C110.5 565.205 115.272 565.639 118.812 566.165C125.079 555.62 139.403 530.592 146.566 514.835C153.728 499.078 177.602 435.254 188.644 405.311C194.911 392.877 212.936 367.411 234.901 365.023C256.865 362.636 271.309 366.615 275.785 368.903H574.214C578.691 366.615 593.135 362.636 615.099 365.023C637.064 367.411 655.089 392.877 661.356 405.311C672.398 435.254 696.272 499.078 703.434 514.835C710.597 530.592 724.921 555.62 731.188 566.165C734.728 565.639 739.5 565.205 744.951 564.709C759.106 563.421 777.839 561.717 791.471 556.915C817.733 547.664 838.623 513.343 843.995 479.92C860.908 374.69 837.713 270.264 828.133 227.133C827.607 224.762 827.121 222.576 826.686 220.585C816.828 175.522 777.146 67.7895 761.926 46.3026C759.81 43.3143 754.583 42.3933 750.986 41.7595C748.945 41.3998 747.428 41.1326 747.303 40.6325C746.706 38.2451 745.612 29.889 745.214 25.4126C739.843 22.0304 726.234 14.1901 715.968 9.89268C703.136 4.52095 685.23 0.641191 669.115 0.0443326C656.223 -0.433154 636.288 3.02869 635.094 4.52256C634.494 5.27389 634 9.03246 633.528 12.6268C633.062 16.179 632.616 19.5708 632.11 19.7407C631.955 19.7925 631.669 19.93 631.28 20.1164C629.417 21.0102 625.208 23.029 621.963 22.1281C611.22 19.1456 589.104 15.4194 546.759 11.6833C504.813 7.98219 453.514 7.25491 425 6.90839C396.486 7.25491 345.187 7.98219 303.241 11.6833C260.896 15.4194 238.78 19.1456 228.037 22.1281C224.791 23.029 220.583 21.0102 218.72 20.1164Z"
      fill="#E5E9F2"
    />
    <circle cx="287.686" cy="278.434" r="53.7172" fill="#A7AEBA" />
    <circle cx="562.24" cy="278.434" r="53.7172" fill="#A7AEBA" />
    <circle cx="287.686" cy="278.434" r="33.3047" fill="#DDE2ED" />
    <circle cx="562.24" cy="278.434" r="33.3047" fill="#DDE2ED" />
    <circle cx="690.565" cy="224.717" r="28.6492" fill="#A7AEBA" />
    <path
      d="M690.565 226.446L677.372 239.638L675.644 237.91L688.836 224.717L675.644 211.524L677.372 209.795L690.565 222.988L703.758 209.795L705.486 211.524L692.294 224.717L705.486 237.91L703.758 239.638L690.565 226.446Z"
      fill="white"
    />
    <circle cx="752.638" cy="162.644" r="28.6492" fill="#A7AEBA" />
    <path
      d="M768.754 162.644C768.754 171.545 761.539 178.76 752.638 178.76C743.738 178.76 736.523 171.545 736.523 162.644C736.523 153.744 743.738 146.529 752.638 146.529C761.539 146.529 768.754 153.744 768.754 162.644Z"
      stroke="white"
      strokeWidth="2.38743"
    />
    <rect
      x="617.034"
      y="47.4497"
      width="22.0838"
      height="41.1832"
      rx="11.0419"
      transform="rotate(10.6936 617.034 47.4497)"
      fill="#A7AEBA"
    />
    <rect
      width="22.0838"
      height="41.1832"
      rx="11.0419"
      transform="matrix(-0.982633 0.185558 0.185558 0.982633 233.585 47.4497)"
      fill="#A7AEBA"
    />
    <circle cx="628.492" cy="162.644" r="28.6492" fill="#A7AEBA" />
    <rect
      x="614.764"
      y="148.916"
      width="27.4555"
      height="27.4555"
      stroke="white"
      strokeWidth="2.38743"
    />
    <circle cx="690.565" cy="100.571" r="28.6492" fill="#A7AEBA" />
    <path
      d="M706.083 111.016H674.45L690.267 83.8589L706.083 111.016Z"
      stroke="white"
      strokeWidth="2.38743"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M217.902 19.8328C217.57 18.8382 216.984 16.3024 216.535 12.8862L216.535 12.8824C216.299 11.0884 216.057 9.245 215.799 7.75588C215.669 7.01103 215.535 6.3483 215.393 5.82138C215.323 5.55794 215.249 5.32368 215.171 5.12772C215.095 4.93567 215.009 4.76278 214.907 4.63469C214.789 4.48732 214.59 4.36248 214.37 4.25231C214.139 4.13696 213.844 4.01858 213.495 3.89803C212.797 3.65664 211.859 3.39806 210.736 3.13341C208.487 2.60374 205.471 2.04443 202.094 1.54736C195.34 0.553573 187.113 -0.195164 180.642 0.0445314C164.494 0.642597 146.553 4.52905 133.684 9.91582C123.397 14.2223 109.773 22.0722 104.394 25.4585L104.269 25.5373L104.256 25.6846C103.858 30.1612 102.765 38.4962 102.175 40.8585L102.063 41.3071L159.029 30.9755L217.902 19.8328Z"
      fill="#A7AEBA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M632.073 19.8328C632.406 18.8382 632.992 16.3024 633.44 12.8862L633.441 12.8824C633.676 11.0884 633.918 9.245 634.177 7.75588C634.306 7.01103 634.441 6.3483 634.582 5.82138C634.653 5.55794 634.727 5.32368 634.804 5.12772C634.88 4.93567 634.966 4.76278 635.069 4.63469C635.187 4.48732 635.385 4.36248 635.606 4.25231C635.837 4.13696 636.132 4.01858 636.48 3.89803C637.178 3.65664 638.116 3.39806 639.24 3.13341C641.489 2.60374 644.504 2.04443 647.882 1.54736C654.635 0.553573 662.862 -0.195164 669.334 0.0445314C685.482 0.642597 703.423 4.52905 716.291 9.91582C726.579 14.2223 740.203 22.0722 745.581 25.4585L745.706 25.5373L745.719 25.6846C746.117 30.1612 747.21 38.4962 747.801 40.8585L747.913 41.3071L690.947 30.9755L632.073 19.8328Z"
      fill="#A7AEBA"
    />
    <path
      d="M243.433 29.7601C242.503 23.0278 247.317 16.8918 254.088 16.3036C284.59 13.6538 365.014 7.16162 420.785 7.16162C476.556 7.16162 556.98 13.6538 587.482 16.3036C594.253 16.8918 599.067 23.0278 598.137 29.7601L579.866 162.091C577.012 182.761 559.345 198.156 538.479 198.156H303.091C282.225 198.156 264.558 182.761 261.704 162.091L243.433 29.7601Z"
      fill="#A7AEBA"
    />
    <path
      d="M132.049 107.829C131.631 101.024 136.491 95.0296 143.237 94.0331L145.359 93.7195C153.456 92.5233 161.685 92.5233 169.782 93.7195L171.905 94.0331C178.65 95.0296 183.511 101.024 183.092 107.829L181.788 129.02C181.567 132.603 180.01 135.972 177.424 138.461L161.71 153.586C159.399 155.811 155.743 155.811 153.432 153.586L137.717 138.461C135.131 135.972 133.574 132.603 133.353 129.02L132.049 107.829Z"
      fill="#A7AEBA"
    />
    <path
      d="M164.733 117.282H150.408L157.571 109.523L164.733 117.282Z"
      fill="white"
    />
    <path
      d="M132.049 216.86C131.631 223.666 136.491 229.66 143.237 230.657L145.359 230.97C153.456 232.167 161.685 232.167 169.782 230.97L171.905 230.657C178.65 229.66 183.511 223.666 183.092 216.86L181.788 195.67C181.567 192.087 180.01 188.718 177.424 186.229L161.71 171.104C159.399 168.879 155.743 168.879 153.432 171.104L137.717 186.229C135.131 188.718 133.574 192.087 133.353 195.67L132.049 216.86Z"
      fill="#A7AEBA"
    />
    <path
      d="M164.733 207.408H150.408L157.571 215.167L164.733 207.408Z"
      fill="white"
    />
    <path
      d="M212.086 136.824C218.892 136.405 224.886 141.265 225.882 148.011L226.196 150.133C227.392 158.23 227.392 166.459 226.196 174.556L225.882 176.679C224.886 183.424 218.892 188.285 212.086 187.866L190.895 186.562C187.313 186.341 183.943 184.784 181.454 182.198L166.329 166.484C164.105 164.173 164.105 160.517 166.329 158.206L181.454 142.492C183.943 139.905 187.313 138.348 190.895 138.128L212.086 136.824Z"
      fill="#A7AEBA"
    />
    <path
      d="M202.633 169.507L202.633 155.183L210.393 162.345L202.633 169.507Z"
      fill="white"
    />
    <path
      d="M103.055 136.824C96.2494 136.405 90.2554 141.265 89.2589 148.011L88.9453 150.133C87.7492 158.23 87.7492 166.459 88.9453 174.556L89.2589 176.679C90.2554 183.424 96.2494 188.285 103.055 187.866L124.246 186.562C127.829 186.341 131.198 184.784 133.687 182.198L148.812 166.484C151.036 164.173 151.036 160.517 148.812 158.206L133.687 142.492C131.198 139.905 127.829 138.348 124.246 138.128L103.055 136.824Z"
      fill="#A7AEBA"
    />
    <path
      d="M112.508 169.507L112.508 155.183L104.749 162.345L112.508 169.507Z"
      fill="white"
    />
  </svg>
);
